import axios from "axios";
import { apiClient, API_URL, SESSION_ID } from "./apiConfig";

// This file contains API calls related to the Party Builder for the GoodGlows application

export const userDashboardAPI = {
	getUserDashboard: async (memberID) => {
		const response = await apiClient.get(
			`/getuserdashboard/?memberID=${memberID}`,
			{ sessionid: SESSION_ID() }
		);
		return response.data;
	},

	getMySalutes: async (memberID) => {
		const response = await apiClient.get(
			`/getmysalutes/?memberID=${memberID}`,
			{ sessionid: SESSION_ID() }
		);
		return response.data;
	},

	getMySentStarSalutes: async (memberID, page = 1, pageSize = 10) => {
		const response = await apiClient.get(
			`/getmysalutes/?memberID=${memberID}&sent=true&filter=star&page=${page}&pageSize=${pageSize}`,
			{ sessionid: SESSION_ID() }
		);
		return response.data;
	},

	getMySentSecretSalutes: async (memberID, page = 1, pageSize = 10) => {
		const response = await apiClient.get(
			`/getmysalutes/?memberID=${memberID}&sent=true&filter=secret&page=${page}&pageSize=${pageSize}`,
			{ sessionid: SESSION_ID() }
		);
		return response.data;
	},
};
